/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebContent {

    "use strict";

    export class SettingsController {
        public static $inject : string[ ] = [
            'CurrentUser',
            '$timeout',
            '$scope',
            '$state',
            '$resource'
        ];

        public modal: any;

        // Stubbed out loaner agreement file upload.  Need actual page design to do
        // much more than this.
        //
        constructor(
            public CurrentUser  : any,
            public $timeout     : any,
            public $scope       : any,
            public $state       : any,
            public $resource    : any
        ) {
            var that = this;

        }

    }

    getDealerwareWebContentModule().controller('SettingsController', SettingsController);

}
